import React, { useEffect, useRef } from 'react';

import { useInfiniteLoader } from '@/hooks/useInfiniteLoader';

interface InfiniteLoaderProps {
  onLoadMore: () => void;
  triggerOnce?: boolean;
  triggerOffsetPx?: `${string}px`;
}

export const InfiniteLoader: React.FC<InfiniteLoaderProps> = ({
  onLoadMore,
  triggerOnce = true,
  triggerOffsetPx
}) => {
  const { measureRef, isIntersecting } = useInfiniteLoader({
    distance: triggerOffsetPx
  });
  const hasTriggeredRef = useRef(false);

  useEffect(() => {
    if (isIntersecting && !hasTriggeredRef.current) {
      onLoadMore();

      if (triggerOnce) hasTriggeredRef.current = true;
    }
  }, [isIntersecting, triggerOnce]);

  return <div ref={measureRef} />;
};
